export const CATEGORIES_NAME = "CATEGORIES_NAME";
export const SHOW_CATEGORIES_NAME = "SHOW_CATEGORIES_NAME";
export const CLEAR_CATEGORIES_NAME = "CLEAR_CATEGORIES_NAME";